import request from 'utils/request';

export function fetchSubscriptionPlans(params, options = {}) {
  const requestOptions = {
    ...options,
    method: 'GET',
  };

  return request('/api/v3/subscription-plans', requestOptions);
}
